import { lazy, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

import PartnerInfo from '@/components/Modals/PartnerInfo/PartnerInfo';

import { getStoreFormats } from '@/store/slices/app';

import styles from './Main.module.scss';


const Header = lazy(() => import('@/components/Header/Header'));
const Head = lazy(() => import('@/components/Head/Head'));
const About = lazy(() => import('@/components/About/About'));
const Features = lazy(() => import('@/components/Features/Features'));
const Formats = lazy(() => import('@/components/Formats/Formats'));
const StartPack = lazy(() => import('@/components/StartPack/StartPack'));
const Faq = lazy(() => import('@/components/Faq/Faq'));
const HowToParticipate = lazy(() => import('@/components/HowToParticipate/HowToParticipate'));
const Partners = lazy(() => import('@/components/Partners/Partners'));

const mainPartnerDesk = {
  adInfo: {
    company: 'ПАО "Промсвязьбанк"',
    inn: 7744000912,
    token: '2VtzqwsTdWL',
  },
};

const mainPartnerMobi = {
  adInfo: {
    company: 'ПАО "Промсвязьбанк"',
    inn: 7744000912,
    token: '2VtzqupsHmn',
  },
};

function Main() {
  const formats = useSelector(getStoreFormats)
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [isOpenPartnerInfo, setIsOpenPartnerInfo] = useState(false);

  return (
    <>
      <Header />
      <Head />
      <About />
      <Features />

      <div className={`${styles.bg} ${formats?.length ? styles.bgWithFormats : ''}`}>
        <HowToParticipate />
        <Formats />
        <StartPack />
      </div>

      <Faq />
      {/* <Partners /> */}
      {/* <Footer /> */}

      {isOpenPartnerInfo && (
        <PartnerInfo
          partner={isMobile ? mainPartnerMobi : mainPartnerDesk}
          isOpen={isOpenPartnerInfo}
          onClose={() => setIsOpenPartnerInfo(false)}
        />
      )}
    </>
  );
}

export default Main;
